import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'aa-privacy-policy-view',
  standalone: true,
  imports: [],
  templateUrl: './privacy-policy-view.component.html',
  styleUrl: './privacy-policy-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyPolicyViewComponent {}
